
export class TokenAuth0Request {
  client_id: string;
  client_secret: string;
  audience: string;
  grant_type: string;
}
